import { CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";

import { ModalName } from "components/organisms/ModalRoot/ModalRoot.layout";

import { openModal } from "../../../../redux/slices/modal/modal.slice";

/**
 * Google webhook (gglw) picker for LeadsStep1: choose an existing connected
 * webhook or open the create modal. The selected id/name stay in LeadsStep1
 * because toNext() builds the step payload from them.
 */
const GoogleLeadSourceSection = ({
    selectedConnectedSourceApiId,
    handleGoogleSourceChange,
    setNextButtonDisabled,
}) => {
    const dispatch = useDispatch();
    const language = useSelector((state) => state.languagesState.languages);
    const googleConnectedSources = useSelector(
        (state) => state.leadAllSourcesState.googleConnectedSourcesList,
    );

    return (
        <>
            {!!googleConnectedSources?.data?.length && (
                <Form.Group
                    className="mb-2 mt-4"
                    controlId="exampleForm.ControlInput1"
                >
                    <FormControl
                        style={{
                            width: "100%",
                        }}
                    >
                        <Select
                            id="id"
                            label={"Select Google Webhook"}
                            onChange={(event) => {
                                handleGoogleSourceChange(
                                    event.target.value,
                                    googleConnectedSources?.data.find(
                                        (x) => x?.id === event.target.value,
                                    ),
                                );
                                setNextButtonDisabled(false);
                            }}
                            value={selectedConnectedSourceApiId}
                        >
                            {googleConnectedSources?.data &&
                                googleConnectedSources?.data.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Form.Group>
            )}
            {(googleConnectedSources?.isLoadingList ||
                !!googleConnectedSources?.data?.length) && (
                <div className="wizard-or-area mt-2 mb-2">
                    {googleConnectedSources?.isLoadingList ? (
                        <CircularProgress size={16} color="primary" />
                    ) : (
                        "Or Create New Google Lead Webhook"
                    )}
                </div>
            )}
            <Button
                className="py-2 w-full tour-create-source-api-btn"
                variant="outlined"
                color="primary"
                onClick={() => {
                    dispatch(
                        openModal({
                            modalName: ModalName.ADD_EDIT_LEAD_GOOGLE,
                        }),
                    );
                }}
            >
                {language?.lead?.create_new_source_api ??
                    "Create New Google Lead Webhook"}
            </Button>
        </>
    );
};

export default GoogleLeadSourceSection;
